import { ListBox } from 'primereact/listbox';
import { ProgressSpinner } from 'primereact/progressspinner';
import { useEffect, useRef, useState } from 'react';
import { getUsuariosActivos } from '../../services/Roles/RolesService';
import { Button } from 'primereact/button';
import { Toast } from 'primereact/toast';

const AdicionUsuarioRol = ({ onSave, tituloRol }) => {
    const [usuarioSelect, setUsuarioSelect] = useState();
    const [lstUsuarios, setLstUsuarios] = useState([]);
    const [cargaUser, setCargaUser] = useState(false);
    const [procesaAgregar, setProcesaAgregar] = useState(false);

    const toastAdi = useRef();

    useEffect(() => {
        const recuperaUsuarios = async () => {
            try {
                setCargaUser(true);
                const usuarios = await getUsuariosActivos();
                //console.log('XX0=', usuarios);
                setLstUsuarios(usuarios);
            } catch (error) {
                console.error('ERROR:', error.message);
            } finally {
                setCargaUser(false);
            }
        };
        recuperaUsuarios();
    }, []);

    const handleClick = () => {
        if (usuarioSelect && usuarioSelect.length !== 0) {
            setProcesaAgregar(true);
            const listaIds = usuarioSelect.filter((item) => Number.isInteger(item.usuarioId)).map((item) => item.usuarioId);
            const dataGuardar = {
                listaUser: listaIds
            };
            //console.log('WW0:', dataGuardar)
            onSave(dataGuardar);
        } else {
            toastAdi.current.show({ severity: 'warn', summary: 'Atencion', detail: 'Debe seleccionar un usuario' });
        }
    };

    return (
        <div className="card">
            <h4>
                Rol: <strong>{tituloRol}</strong>{' '}
            </h4>
            <Toast ref={toastAdi} />
            <div className="formgrid grid p-fluid mb-3">
                <div className="field col-12 md:col-9">
                    <label>Seleccionar los Usuarios para adicionar:</label>
                    {cargaUser ? (
                        <div className="flex align-items-center">
                            <ProgressSpinner style={{ width: '20px', height: '20px' }} strokeWidth="8" />
                        </div>
                    ) : (
                        <ListBox filter multiple value={usuarioSelect} options={lstUsuarios} onChange={(e) => setUsuarioSelect(e.value)} optionLabel="username" className="w-full " listStyle={{ height: '200px' }} />
                    )}
                </div>
                <div className="field col-12 md:col-3">
                    <Button label="Agregar" onClick={handleClick} loading={procesaAgregar} />
                </div>
            </div>
        </div>
    );
};

export default AdicionUsuarioRol;
